import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router';

import { UserModel } from '../../api/authentication/authentication.types';
import { AppState } from '../../store/store.types';
import ReservationDetails from './view/ReservationDetails';
import Reservations from './view/Reservations';
import ReservationLogsTableView from './view/ReservationLogsTableView';
import ReservationAuditLog from './view/ReservationAuditLog';

interface ReservationEntryProps extends RouteComponentProps {
  user: UserModel;
}

class ReservationEntry extends React.PureComponent<PropsWithChildren<ReservationEntryProps>> {
  render() {
    return (
      <>
        {this.props.children}
        <Route
          exact
          path={`${this.props.match.path}`}
          render={(routeProps) => <Reservations {...routeProps} />}
        />
        <Route
          exact
          path={`${this.props.match.path}/:number/view`}
          render={(routeProps) => <ReservationDetails {...routeProps} />}
        />
        <Route
          exact
          path={`${this.props.match.path}/:number/view/logs/:type`}
          render={(routeProps) =>
            <ReservationLogsTableView {...routeProps} />}
        />
        <Route
          exact
          path={`${this.props.match.path}/:number/view/audit`}
          render={(routeProps) => <ReservationAuditLog {...routeProps} />}
        />
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user
});

const reservationEntry = connect(mapStateToProps, null)(ReservationEntry);

export default {
  reservationEntry
};
